export default {
  getAccountStatements: (state) => state.accountStatement.map((entry) => ({
    ...entry,
    split_booking: entry.splits,
  })),
};
